export const redirecionamentoTelemedicinaProps = {
  basename: "/plataforma/redirecionamento-telemedicina",
};

export const dataErrorTelemedicinaProps = {
  basename: "/plataforma/cadastro-parcial-telemedicina",
};

export const sistemaIndisponivelTelemedicinaProps = {
  basename: "/plataforma/sistema-indisponivel-telemedicina",
};
